import { Routes, matchesRoutePath } from './Routes';

export function isSecureRoute(path: string) {
  return Object.values(Routes).some((item) => {
    if (!('secured' in item)) {
      return false;
    }
    return item.secured && matchesRoutePath(item.path, path);
  });
}
